<template>
  <iframe
    title="Youtube video"
    :src="`https://www.youtube.com/embed/${videoId}`"
    frameborder="0"
    allowfullscreen
    width="560"
    height="315"
    class="mb-40"
    referrerpolicy="strict-origin-when-cross-origin"
  ></iframe>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Url: string;
  };
}
const props = defineProps<Props>();

const videoId = computed(() => {
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]{11}).*/;
  const match = props.configData?.Url?.match(regExp);
  return match && match[2] ? match[2] : null;
});
</script>

<style scoped></style>
